import React from 'react';
import BasicModal from '../../components/Modals/BasicModal';

const VehiclePagecard2 = (props) => {
    return (
        <div className=" w-96 md:w-full border-x border-b  border-gray-300  shadow-md h-[350px] bg-white rounded-md mt-3 md:mt-1">
            <div className="flex w-full  bg-[#2374BF] text-white    rounded-t-lg font-semibold ">
                <p className=" text-md p-1 pl-2  w-full">{props.heading}</p>

                {/* Trigger button/icon */}
                {props.trigger && (
                    <div onClick={props.handleOpenModal} className="cursor-pointer ml-2">
                        {props.trigger}
                    </div>
                )}

                {/* Modal */}
                <BasicModal
                    open={props.open}
                    handleOpenModal={props.handleOpenModal}
                    handleCloseModal={props.handleCloseModal}
                    title={props.heading + " Details"}
                >
                    {props.modalContent}
                </BasicModal>
            </div>

            {props.vcards}
            {props.des}
        </div>
    );
};

export default VehiclePagecard2;
